import PropType from 'prop-types';
import { StepConnector, withStyles } from '@material-ui/core';

const styles = theme => ({
  root: {
    marginLeft: '1.25rem',
    padding: 0,
  },
  line: {
    borderStyle: props => props.variant,
    borderColor: theme.palette.secondary[100],
    borderWidth: '1px',
  },
});

StepConnector.propTypes = {
  variant: PropType.string,
};

StepConnector.defaultProps = {
  variant: '',
};

export default withStyles(styles)(StepConnector);
